'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_CONTENT = exports.EDIT_ITEM = exports.ADD_CONTENT = exports.REMOVE_VIDEO = exports.EDIT_VIDEO = exports.ADD_VIDEO = exports.VIDEOS = undefined;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIDEOS = exports.VIDEOS = _constantsAnalytics2.default.CATEGORIES.VIDEOS;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_VIDEO = _analyticsConstants$E.ADD_VIDEO,
    EDIT_VIDEO = _analyticsConstants$E.EDIT_VIDEO,
    REMOVE_VIDEO = _analyticsConstants$E.REMOVE_VIDEO;
exports.ADD_VIDEO = ADD_VIDEO;
exports.EDIT_VIDEO = EDIT_VIDEO;
exports.REMOVE_VIDEO = REMOVE_VIDEO;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    EDIT_ITEM = _analyticsConstants$A.EDIT_ITEM,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT;
exports.ADD_CONTENT = ADD_CONTENT;
exports.EDIT_ITEM = EDIT_ITEM;
exports.REMOVE_CONTENT = REMOVE_CONTENT;


function composeRatingEvent(eventName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: 1,
    gtmLabel: undefined,
    gtmCategory: VIDEOS,
    gtmAction: action
  });
}

function composeAddVideoEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(ADD_VIDEO, ADD_CONTENT)]);
}

function composeEditVideoEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(EDIT_VIDEO, EDIT_ITEM)]);
}

function composeRemoveVideoEvent() {
  return (0, _compose.composeAnalytics)([composeRatingEvent(REMOVE_VIDEO, REMOVE_CONTENT)]);
}

exports.default = {
  composeAddVideoEvent: composeAddVideoEvent,
  composeEditVideoEvent: composeEditVideoEvent,
  composeRemoveVideoEvent: composeRemoveVideoEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/videosEventComposer.js
// module id = 590
// module chunks = 0 2 4 5 6 8 9 10 11